@if (loading()) {
	<div class="chemical-usage-log-row__loading">
		<tui-icon icon="@tui.loader" />
	</div>
} @else {
	<div class="chemical-usage-log-row__information">
		<p class="chemical-usage-log-row__information-title line-clamp-1">
			{{ usageLog().location }}
		</p>

		<p
			class="chemical-usage-log-row__information-subtitle line-clamp-2"
			[innerHtml]="
				'chemical.usage-log.applied-date'
					| transloco
						: {
								date:
									appliedAtDate()
									| date: 'MMMM d, yyyy hh:mm aa',
						  }
			"
		></p>

		<small
			class="chemical-usage-log-row__information-small line-clamp-1"
			[tuiHint]="chemicalTooltip()"
			tuiHintAppearance="dark"
		>
			{{ chemical()?.name ?? ('chemical.unknown' | transloco) }}
		</small>
	</div>

	<div class="chemical-usage-log-row__actions">
		<ctx-chemical-rei-badge size="xl" [reiDate]="reiDate()" />

		<button
			size="m"
			tuiIconButton
			appearance="ghost"
			[tuiHint]="'chemical.usage-log.view-details' | transloco"
			tuiHintAppearance="dark"
			(click)="onViewDetails()"
		>
			<tui-icon icon="@tui.info" />
		</button>
	</div>
}
